export const accountKeys = {
	all: ['account'] as const,
	info: () => [...accountKeys.all, 'info'] as const,
};